import { eventPitches } from '../utils/noteEvents';

/**
 * The distinct { note, velocity } pairs each instrument track's clips will play,
 * keyed by track id. Engines with hosted instruments stream exactly these
 * recordings ahead of playback and before an export renders.
 */
export function instrumentNotesByTrack(clips = []) {
  const byTrack = new Map();
  (clips || []).forEach((clip) => {
    if (clip?.clipType !== 'pattern' || clip?.clipData?.kind !== 'instrument' || clip.muted) return;
    const trackId = clip.clipData.instrumentTrackId || clip.trackId;
    if (!byTrack.has(trackId)) byTrack.set(trackId, new Map());
    const notes = byTrack.get(trackId);
    (clip.clipData.noteEvents || []).forEach((event) => {
      if (!event || event.muted || event.velocity === 0) return;
      const raw = Number(event.velocity);
      const velocity = Number.isFinite(raw) ? Math.max(0.01, Math.min(1, raw)) : 0.82;
      eventPitches(event).forEach((note) => {
        const key = `${note}:${Math.round(velocity * 127)}`;
        if (!notes.has(key)) notes.set(key, { note, velocity });
      });
    });
  });
  return new Map([...byTrack].map(([trackId, notes]) => [trackId, [...notes.values()]]));
}
